<template>
  <div class="right-insurance-info">
    <img :src="insuranceData.logo" alt="">
    <div class="info-title">{{insuranceData.product_name}}-{{insuranceData.plan_name}}</div>
    <div class="info-content">
      <div class="info-project">
        <span class="item-title">保障天数</span>
        <span class="item-content">{{insuranceData.protect_days}}</span>
      </div>
      <div class="info-project" v-if="insuranceData.insurant_age">
        <span class="item-title">承保年龄</span>
        <span class="item-content">{{insuranceData.insurant_age}}</span>
      </div>
      <div class="info-project" v-if="insuranceData.travel_delays !== undefined">
        <span class="item-title">旅行延误升级</span>
        <span class="item-content">{{insuranceData.travel_delays ? '是':'否'}}</span>
      </div>
      <div class="info-project">
        <span class="item-title">份数</span>
        <span class="item-content">{{insuranceData.insurants.length}}份</span>
      </div>
    </div>
    
    <div class="info-total">
      <div class="price-box">
        <span>实付金额</span><span class="info-orange">¥ <span>{{insuranceData.single_price * insuranceData.insurants.length | price}}</span></span>
      </div>
      <div class="price-box original-price-box" v-if="insuranceData.original_price">
        <span>原价</span><span class="info-default">¥ <span>{{insuranceData.original_price * insuranceData.insurants.length | price}}</span></span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    insuranceData: {
      type: Object,
    },
  },
};
</script>


<style lang="less" scoped>
.right-insurance-info {
  img {
    height: 24px;
    margin-bottom: 12px;
  }
  .info-title {
    color: #2F333D;
    font-size: 20px;
    line-height: 32px;
    font-weight: 600;
    position: relative;
    z-index: 1;
    margin-bottom: 4px;
    &::after{
      content: "";
      position: absolute;
      left: 0;
      top: 23px;
      width:82px;
      height:7px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
      z-index: -1;
    }
  }
  .info-content {
    background-color: #FAFBFC;
    padding: 16px 12px;
    margin-bottom: 12px;
    overflow: hidden;
    .info-project {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      line-height: 1;
      margin-bottom: 24px;
      &:last-child{
        margin-bottom: 0;
      }
      .item-title {
        color: #5F666E;
        flex-shrink: 0;
      }
      .item-content {
        color: #2F333D;
      }
    }
  }
  .info-total {
    .price-box {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      font-size: 14px;
      color: #2F333D;
      line-height: 1;
      .info-orange {
        line-height: 1;
        color: #FF8033;
        font-size: 16px;
        font-weight: 600;
        span {
          font-size: 32px;
        }
      }
      &.original-price-box {
        color: #91999F;
      }
      .info-default{
        margin-top: 8px;
        font-size: 14px;
        text-decoration: line-through;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/right-insurance-info.vue